import Image from 'next/image';
import { FC } from 'react';

import PreHeading from '../PreHeading';
import BlokLink from '../StoryblokLink/BlokLink';

export interface FeaturedPostsProps {
  posts: [];
  title: string;
}

const FeaturedPosts: FC<FeaturedPostsProps> = ({ posts, title }) => {
  return (
    <>
      <PreHeading
        size=""
        element="h3"
        color="text-theme-darkgrey"
        className="mb-4 grid grid-cols-[auto_1fr] gap-2 align-middle text-[0.8rem] font-extralight tracking-widest text-theme-darkgrey lg:mb-6"
      >
        {title}
        <div className="h-px bg-theme-midgrey/20"></div>
      </PreHeading>
      <div className="grid gap-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 lg:gap-6">
        {posts.map((p: any) => {
          return (
            <BlokLink
              key={p.uuid}
              {...p}
              className="group relative overflow-hidden"
            >
              <Image
                src={p.content?.hero_feature_image?.filename}
                alt={p.name}
                fill
                className="absolute object-cover duration-1000 group-hover:scale-110"
              />
              <div
                className="relative flex aspect-[4/3] items-end p-2 px-4 text-theme-darkgrey"
                style={{
                  backgroundImage: `radial-gradient(83.69% 83.69% at 16.88% 100%, #282828 0%, rgba(40, 40, 40, 0) 100%)`,
                  backgroundSize: 'cover, cover',
                }}
              >
                <span className="self-end font-semibold text-white">
                  {p.name}
                </span>
              </div>
            </BlokLink>
          );
        })}
      </div>
    </>
  );
};

export default FeaturedPosts;
